export default "__VITE_ASSET__8b8d0093__"